import { render, staticRenderFns } from "./CommentInpute.vue?vue&type=template&id=827c4e2c"
import script from "./CommentInpute.vue?vue&type=script&lang=ts"
export * from "./CommentInpute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports